import { $authHost } from "../index"

export const checkWorkPlaceNowAPI = async () => {
    const {data} = await $authHost.post('api/work_place/now/')
    return data
}

export const checkChangeWorkPlaceAPI = async ({ scaned }) => {
    const {data} = await $authHost.post('api/work_place/change/check', {scaned})
    return data
}

export const changeWorkPlaceAPI = async ({ scaned }) => {
    const {data} = await $authHost.post('api/work_place/change/', {scaned})
    return data
}

export const getUsersInDepartmentAPI = async ({ departmentType, departmentId }) => {
    const {data} = await $authHost.post('api/work_place/users_in_department/', { departmentType, departmentId })
    return data
}